module.exports = __webpack_public_path__ + "static/img/powerpoint.672933c4.svg";